var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position)?_c('FrsFabOverlay',{attrs:{"position":_vm.position,"centered":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }